import { ApplicationPageDetails } from 'src/app/shared/models/application-page-details.interface';

export class Userinfo {
  EmpCode: number;
  Email: string;
  DesignationName: string;
  Department: string;
  NamePerRecords: string;
  DOJ: Date;
  permissions: ApplicationPageDetails[];
  menu: MainMenu[];
  Token: string;
}
export class MainMenu {
  Menu: string;
  Name: string;
  URL: string;
  SubMenu: SubMenu[];
}
export class SubMenu {
  Menu: string;
  Name: string;
  URL: string;
}
